import TableLayout from '../../../../layout/main/TableLayout'
import { Column, DText, Flex, Relative, Row } from '../../../../../styles/CommonStyles'
import Text from '../../../../../core/utils/Text'
import DateTime from '../../../../common/utils/DateTime'
import UserLink from '../../../../common/utils/UserLink'
import useGetTableIndex from '../../../../../core/hooks/layout/useGetTableIndex'

import { fiatAccountsAttributes } from '../../../../../core/constants/headers'
import Operation from '../../../../common/utils/Operation'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { useState } from 'react'
import BasicModal from '../../../../modals/BasicModal'
import ModalLayout from '../../../../layout/main/ModalLayout'
import { useResubmitVa } from '../../../../../core/services/react-query/report/due-payments'
import { FiatAccStatusBadge } from './stausBadge'

const FiatAccountTable = ({ data }) => {
    const { data: recipients } = data
    const { cs, headers } = fiatAccountsAttributes
    const { getTableIndex } = useGetTableIndex()
    const navigate = useNavigate();
    const [modal, setModal] = useState({ open: false, account: null })
    const onCloseModal = () => setModal({ open: false, account: null })
    const { mutate, isLoading } = useResubmitVa(onCloseModal)


    return (
        <>
            <TableLayout headers={headers} cs={cs} data={data}>
                {recipients?.data?.map((item, idx) => {

                    return (
                        <Relative key={item._id}>
                            <Row cs={cs} index={idx}>
                                {/* INDEX */}
                                <Column>{getTableIndex(idx)}</Column>

                                {/* USER */}
                                <Column avatar>
                                    <UserLink
                                        _id={item.userId}
                                        name={item.userId}
                                    />
                                </Column>

                                {/* USER */}
                                <Column avatar>
                                    <div className="text-ellipsis max-w-[200px] overflow-clip text-nowrap">

                                        {item?.user?.firstName || ''} {item?.user?.lastName || ''}
                                    </div>
                                </Column>

                                {/* USER */}
                                <Column avatar>
                                    {item?.user?.email || ''}
                                </Column>


                                {/* ACCOUNT ID */}
                                <Column>
                                    <Text tid={item.accountId} />
                                </Column>

                                {/* STATUS */}
                                <Column>
                                    <FiatAccStatusBadge status={item.meta?.kyc?.status || item.kyc} >
                                        <DText main>
                                            {item.meta?.kyc?.status || "-"}
                                        </DText>
                                    </FiatAccStatusBadge>
                                </Column>

                                {/* KYC Result */}
                                <Column>
                                    <FiatAccStatusBadge status={item?.kyc?.status || item?.kyc} >
                                        <DText main>
                                            {item?.kyc?.status || item?.kyc}
                                        </DText>
                                    </FiatAccStatusBadge>
                                </Column>

                                {/* CREATED AT */}
                                <Column>
                                    <DateTime dt={item.createdAt} />
                                </Column>
                            </Row>

                            <Column operation>
                                <Operation
                                    onOptionClicked={(idx) => { setModal({ open: true, account: item }) }}
                                    options={["resubmit_kyc"]}
                                    hasWriteAccess
                                    hasDetails
                                    onDetailsClicked={() => { navigate(`/reports/due-payments/accounts/${item._id}`) }}
                                />
                            </Column>
                        </Relative>
                    )
                })}
            </TableLayout>
            <ModalLayout width={"550px"} open={modal?.open} onClose={onCloseModal}>
                <BasicModal
                    onClose={onCloseModal}
                    onSubmit={() => { mutate(modal?.account?.userId) }}
                    loading={isLoading}
                    head={"resubmit-account-kyc"}
                    desc={"are-you-sure-to-resubmit-kyc"}
                    _id={modal?.account?.user?.email} />
            </ModalLayout>

        </>
    )
}

export default FiatAccountTable

